<template>
	<div>
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<el-form-item label="投放链接ID" prop="tfid">
						<el-input type="number" v-model="formInline.tfid" placeholder="请输入投放链接ID" clearable
							@keyup.enter.native="detailSearch" @clear="detailSearch" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="用户ID" prop="userId">
						<el-input type="number" v-model="formInline.userId" placeholder="请输入用户ID" clearable
							@keyup.enter.native="detailSearch" @clear="detailSearch" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="广告计划ID" prop="projectid">
						<el-input type="number" v-model="formInline.projectid" placeholder="请输入广告计划ID" clearable
							@keyup.enter.native="detailSearch" @clear="detailSearch" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="回传状态" prop="statusB">
						<el-select v-model="statusBList" placeholder="请选择回传状态" clearable @change="detailSearch" style="width: 180px;">
							<el-option v-for="item in statusBOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否漏回传" prop="status">
						<el-select v-model="formInline.status" placeholder="请选择是否漏回传" clearable @change="detailSearch" style="width: 200px;">
							<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间：">
						<el-date-picker
							v-model="dataTime"
							class="pickerData"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							type="daterange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable @change="detailSearch">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="detailSearch">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="detailResetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableLinkData.result" border stripe style="width: 100%;" height="100%" class="tableStyle" v-loading="linkLoading">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column label="用户信息" width="200">
						<template slot-scope="scope">
							<div class="td-info" v-if="scope.row.userInfoVo">
								<p>用户ID：{{ scope.row.userid }}</p>
								<p>用户昵称：{{ scope.row.userInfoVo.nickName || '未绑定昵称' }}</p>
								<p>注册时间：{{ scope.row.userInfoVo.strAddTime }}</p>
								<p>用户系统类型：{{ scope.row.userInfoVo.mos }}</p>
							</div>
							<div class="td-info" v-else>
								<p>用户ID：{{ scope.row.userid }}</p>
								<p>用户昵称：</p>
								<p>注册时间：</p>
								<!--<p>用户系统类型：</p>-->
							</div>
						</template>
					</el-table-column>
					<el-table-column label="小程序信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>appid：{{scope.row.appid}}</p>
								<p>小程序：{{scope.row.appName}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="推广信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p><b>投放链接ID：</b>{{ scope.row.tfid }}</p>
								<p><b>clickId：</b>{{ scope.row.clickid }}</p>
								<p><b>广告计划ID：</b>{{ scope.row.projectid }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="充值信息">
						<template slot-scope="scope">
							<div class="td-info" v-if="scope.row.rechargelog">
								<p>充值金额：{{ scope.row.rechargelog.money }}</p>
								<p>支付单号：{{ scope.row.orderId }}</p>
								<p>充值来源：{{ scope.row.rechargelog.bookName }}&nbsp;&nbsp;({{scope.row.rechargelog.bookid}})</p>
							</div>
							<div class="td-info" v-else>
								<p>充值金额：</p>
								<p>支付单号：</p>
								<p>充值来源：</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="支付状态" width="100">
						<template slot-scope="scope">
							<div>
								<p v-if="scope.row.rechargelog.status == 0" class="danger-text">未成功</p>
								<p v-if="scope.row.rechargelog.status == 1" class="succes-text">已成功</p>
								<p v-if="scope.row.rechargelog.status == 2" class="primary-text">未充值</p>
								<p v-if="scope.row.rechargelog.status == 3" class="warnning-text">已退款</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="rechargeNumber" label="用户累计充值信息" width="140">
						<template slot-scope="scope">
							<div class="td-info">
								<p>累计充值次数：{{ scope.row.times }}</p>
								<p>累计充值金额：{{ scope.row.totalMoney }}</p>
								<p>累计回传次数：{{ scope.row.postTotalNumber }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="是否漏回传" width="110">
						<template slot-scope="scope">
							<span v-if="scope.row.statusB == 0">不符合回传</span>
							<span v-if="scope.row.statusB == 1">已回传</span>
							<span v-if="scope.row.statusB == 2">已漏不回传</span>
						</template>
					</el-table-column>
					<el-table-column label="订单创建时间" width="180">
						<template slot-scope="scope">
							<p>{{ scope.row.addTime }}</p>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="200">
						<template slot-scope="scope">
							<div style="padding: 0 15px;">
								<span class="succes-text" v-if="scope.row.status == 1">已自动回传</span>
								<span class="danger-text" v-if="scope.row.status == 0">未回传</span>
								<span class="succes-text" v-if="scope.row.status == 2">已手动回传</span>
								<el-button type="text" v-has="'missReturn:compensate'" v-if="scope.row.status == 0" @click="repair(scope.row.orderId)" style="margin-left: 25px;">补回传</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChangeLink" @size-change="handleSizeChangeLink" :page-sizes="[20, 50, 100, 200, 500]" :page-size="tableLinkData.pageSize" background :current-page="linkCurrentPage" layout="sizes, prev, pager, next, jumper, ->, total" :total="tableLinkData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { rechargeList, addRechargeRepair } from "@/api/wb/data/return";
export default {
	name: 'RechargeReturnList',
    props:['tfId'],
	data() {
		return {
			loading: false,
			dataTime: [],
			statusBList: [],
			formInline: {
				userId: '',
				statusA: '',
				statusB: '',
				status: '',
				tfid: '',
				agentId: '',
				projectid: '',
				startTime: '',
				endTime: '',
				appId: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
				selectType: 2,
			},
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			dialogInfoVisible: false,
			rowForm: {},
			statusBOptions: [
				{
					value: 1,
					label: '已回传'
				},
				{
					value: 2,
					label: '已手动回传'
				},
				{
					value: 0,
					label: '未回传'
				}
			],
			statusOptions: [
				{
					value: -1,
					label: '不符合回传'
				},
				{
					value: 0,
					label: '已漏'
				},
				{
					value: 1,
					label: '已回传'
				}
			],
			isShowDialogAgent: false,
			tableLinkData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			linkCurrentPage: 1,
			linkLoading: false,
			linkId: ''
		}
	},
	computed: {},
	watch: {
        tfId(newValue) {
            this.tfId = newValue
            console.log(newValue)
            this.formInline.tfid = this.tfId
            this.getTableLinkData()
        },
	},
	created() {
		if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isShowDialogAgent = false
		} else {
			this.isShowDialogAgent = true
		}
	},
	mounted: function () {
        this.linkLoading = true
		console.log('1231123', this.formInline.tfid)
		// this.getTableData()
	},
	methods: {
		//详情搜索和重置
		detailSearch () {
			this.linkLoading = true
			this.linkCurrentPage = 1
			this.getTableLinkData(this.linkId)
		},
		detailResetQuery: function () {
			this.linkLoading = true
			this.$refs['detailformInline'].resetFields()
			this.dataTime = []
			this.getTableLinkData(this.linkId)
		},
		// 详情pageSize切换
		handleSizeChangeLink(val) {
			this.tableData.pageSize = val
			this.linkCurrentPage = 1
			this.linkLoading = true
			this.getTableLinkData(this.linkId)
		},
		handleCurrentChangeLink(value) {
			this.linkCurrentPage = value
			this.linkLoading = true
			this.getTableLinkData(this.linkId)
		},
		repair(orderId) {
			addRechargeRepair({
                orderId: orderId
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.getTableLinkData(this.linkId)
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		tabChange(val) {
			this.tabValue = val;
		},
		// 详情列表
		getTableLinkData() {
			let json2 = {
				pageNo: this.linkCurrentPage,
				pageSize: this.tableData.pageSize
			};
			this.formInline.statusB = this.statusBList.toString()
			this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
			this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			rechargeList(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.tableLinkData = response.data.content
					this.linkLoading = false
				} else {
					this.$message.error(response.data.head.desc)
				}
			}).catch((error) => {
                this.linkLoading = false
                console.log("Error sending data:", error);
            });
		},

	}
}
</script>
<style lang="scss"></style>
